import angular from 'angular'

const toolbarmodule = angular.module('app.components.imageToolbar', [])

export default toolbarmodule.name

toolbarmodule.component('imageToolbar', {
    template: '<div class="et-image-toolbar" ng-transclude></div>',
    transclude: true,
})

toolbarmodule.component('imagePager', {
    bindings: {
        pageInfo: '=', // {currentObj, list, total, currentPage}
        onPage: '&',
    },
    template: `
        <div class="toolbar-group toolbar-pager">
            <div class="toolbar-item" ng-class="{'disabled': $ctrl.pageInfo.currentPage === 1}" ng-click="$ctrl.prev()">
                <i class="icon iconfont icon-fanhui"></i>
            </div>
            <div class="toolbar-item" ng-class="{'disabled': $ctrl.pageInfo.currentPage >= $ctrl.pageInfo.total}" ng-click="$ctrl.next()">
                <i class="icon iconfont icon-gengduo"></i>
            </div>
        </div>
    `,
    controller: ['$timeout', '$q', function ctrl($timeout, $q) {
        function loadImage(src) {
            const defered = $q.defer()
            if (!src) {
                defered.resolve()
            } else {
                const img = new Image()
                img.src = src
                img.onload = function onload() {
                    defered.resolve()
                }
                img.onerror = function onerror() {
                    defered.reject()
                }
            }
            return defered.promise
        }
        this.$onChanges = function onchanges() {
            const { pageInfo } = this
            if (pageInfo) {
                pageInfo.currentObj = pageInfo.currentObj || pageInfo.list[0]
                pageInfo.total = pageInfo.total || pageInfo.list.length
                pageInfo.currentPage = pageInfo.currentPage || 1
            }
        }
        this.prev = function prev() {
            const { pageInfo } = this
            if (pageInfo.currentPage === 1) {
                return
            }
            pageInfo.currentPage -= 1
            pageInfo.currentObj = pageInfo.list[pageInfo.currentPage - 1]
            this.onPage && this.onPage(pageInfo.currentObj, pageInfo.currentPage)
        }
        let isLoading = false
        this.next = function next() {
            const { pageInfo } = this
            if (pageInfo.currentPage === pageInfo.total || isLoading) {
                return
            }
            isLoading = true
            loadImage(pageInfo.list[pageInfo.currentPage].storageKey).finally(() => {
                isLoading = false
                pageInfo.currentPage += 1
                pageInfo.currentObj = pageInfo.list[pageInfo.currentPage - 1]
                this.onPage && this.onPage(pageInfo.currentObj, pageInfo.currentPage)
            })
        }
    }],
})



// WEBPACK FOOTER //
// ./src/app/input/electronImage/contractEntering/imageToolbarComponent.js